import styled from 'styled-components';
import { ErrorMarkup } from 'modules/error';
import { spacing, H4 } from 'ui/theme';
import { SESAccountSection } from './SESAccountSection';
import { PageHeader } from '../PageHeader';
import { Sidebar } from '../Sidebar';
import { Wrapper, MainContent } from '../Page.styled';
import { useSendingPlatformsQueryContext } from '../../../contexts';
import { ITERABLE } from '../../../constants';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
  white-space: nowrap;
`;

export const Heading = styled(H4)`
  margin-bottom: 0;
  margin-right: ${spacing.base};
`;

export const SESPage = () => {
  const { hasError } = useSendingPlatformsQueryContext();

  if (hasError) {
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );
  }

  return (
    <>
      <div>
        <PageHeader sendingPlatform={ITERABLE} />
        <Wrapper>
          <Sidebar sendingPlatform={ITERABLE} />
          <MainContent>
            <Header data-test="sending-platform-details-accounts-header">
              <Heading>Accounts</Heading>
            </Header>
            <SESAccountSection />
          </MainContent>
        </Wrapper>
      </div>
    </>
  );
};
